import { IntegrationEnum } from 'models/InternalIntegrationSetting';

export const DYNAMIC_PRICING_TOOLS = {
  [IntegrationEnum.BEYONDPRICING]: {
    name: 'BeyondPricing',
    url: 'https://www.beyondpricing.com/',
  },
  [IntegrationEnum.DPGO]: {
    name: 'DPGO',
    url: 'https://www.dpgo.com/',
  },
  [IntegrationEnum.NIGHTPRICER]: {
    name: 'Nightpricer',
    url: 'https://nightpricer.com/home',
  },
  [IntegrationEnum.PRICELABS]: {
    name: 'PriceLabs',
    url: 'https://pricelabs.co/',
  },
  [IntegrationEnum.QUIBBLE]: {
    name: 'Quibble',
    url: 'https://quibblerm.com/',
  },
  [IntegrationEnum.TURBOSUITE]: {
    name: 'Turbosuite',
    url: 'http://www.turbosuite.com/',
  },
  [IntegrationEnum.WHEELHOUSE]: {
    name: 'Wheelhouse',
    url: 'https://www.usewheelhouse.com/',
  },
};

export const DYNAMIC_PRICING_TOOLS_PRIORITY_ORDER = [
  IntegrationEnum.PRICELABS,
  IntegrationEnum.WHEELHOUSE,
  IntegrationEnum.BEYONDPRICING,
  IntegrationEnum.DPGO,
  IntegrationEnum.NIGHTPRICER,
  IntegrationEnum.TURBOSUITE,
  IntegrationEnum.QUIBBLE,
];
